import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation();
  return <article className="epk-page">
    <header className="epk-hero"><h1>{t("privacy.title")}</h1><p>{t("privacy.updated")}</p></header>
    <section className="epk-section"><h2>{t("privacy.responsibleTitle")}</h2><p>{t("privacy.responsibleText")}</p></section>
    <section className="epk-section"><h2>{t("privacy.analyticsTitle")}</h2><p>{t("privacy.analyticsText")}</p></section>
    <section className="epk-section"><h2>{t("privacy.consentTitle")}</h2><p>{t("privacy.consentText")}</p></section>
    <section className="epk-section"><h2>{t("privacy.contactTitle")}</h2><p>{t("privacy.contactText")} <a className="editorial-link" href="mailto:kujipy.suun@gmail.com">kujipy.suun@gmail.com</a>.</p></section>
  </article>;
};
export default Privacy;
